import { useState } from "react";
import { Col } from "react-bootstrap";
import { EMAIL_REGEX, PHONE_REGEX } from "../../../../constants";
import { useLanguageContext, useThemeContext } from "../../../../context";
import { Button, TextField } from "../../../common";
import { getCheckPhoneNumber } from "../../../../api";
import Icon from "../../../../assets/icons";

const Step1 = ({ handleSave, navigateToLogin }) => {
  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [isEmailValidated, setIsEmailValidated] = useState(false);
  const [errors, setErrors] = useState({});

  const onChange = (label, value) => {
    if (label === I18n.first_name) {
      setFirstName(value);
    } else if (label === I18n.last_name) {
      setLastName(value);
    } else if (label === I18n.enter_your_phone_number) {
      setPhoneNumber(value);
    } else if (label === I18n.enter_email) {
      setEmail(value);
      setIsEmailValidated(EMAIL_REGEX.test(value) ? true : false);
    }

    setErrors({});
  };

  const handleNext = () => {
    if (!PHONE_REGEX.test(phoneNumber)) {
      setErrors({
        phone_number: I18n.phone_number_format,
      });
      return;
    }

    let paramsForApi = {
      phoneNumber,
    };

    getCheckPhoneNumber(paramsForApi)
      .then((res) => {
        let userDetails = {
          firstName,
          lastName,
          phoneNumber,
          email,
        };

        handleSave(userDetails);
      })
      .catch((err) => {
        setErrors({ phone_number: I18n.phone_already_exists });
      });
  };

  const handleEnterPress = (event) => {
    if (
      event.key === "Enter" &&
      firstName &&
      lastName &&
      phoneNumber &&
      email &&
      !Object.keys(errors).length
    ) {
      handleNext();
    }
  };

  return (
    <>
      <Col md={5} onKeyDown={handleEnterPress}>
        <div className="loginFormBox">
          <div className="signupTextBox">
            <h1
              className="fontSize24 fontWeight700 marBot10"
              style={{ color: theme.text }}
            >
              {I18n.lets_create_account}
            </h1>
            <p className="fontSize14 fontWeight400 marBot0 darkGrayTwo">
              {I18n.signing_oscar_is_fast}
            </p>
          </div>

          <div className="singupFields">
            <TextField
              onChange={onChange}
              label={I18n.first_name}
              placeholder={I18n.first_name}
              value={firstName}
              type="text"
            />

            <TextField
              onChange={onChange}
              label={I18n.last_name}
              placeholder={I18n.last_name}
              value={lastName}
              type="text"
            />
          </div>

          <TextField
            onChange={onChange}
            label={I18n.enter_your_phone_number}
            placeholder={I18n.enter_your_phone_number}
            value={phoneNumber}
            error={errors.phone_number}
            maxLength={11}
            type="numeric"
          />

          <TextField
            onChange={onChange}
            label={I18n.enter_email}
            placeholder={I18n.enter_email}
            value={email}
            type="email"
            OnTextChangeType={"email"}
            error={errors.email}
          />

          <Button
            className={`width100 fontWeight600 fontSize16 cursorPointer marTop20`}
            title={I18n.continue}
            type="secondary"
            handleClick={handleNext}
          />

          <div>
            <p className="fontSize14 marTop20">
              <span className="white">{I18n.already_have_an_account}</span>
              <span
                className="cursorPointer  marLeft5 barclaysBlueColor"
                onClick={navigateToLogin}
              >
                {I18n.login}
              </span>
              <span className="marLeft5">
                <Icon name="arrowRight" viewBox="0 0 18 18 " />
              </span>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
};

export default Step1;
